import React from "react";
import CircularProgress from "@mui/material/CircularProgress"; // Certifique-se de ter o Material-UI instalado

const SubmitButton = ({ loading, onClick, label }) => {
  return (
    <div className="w-full flex flex-row-reverse">
      <button
        className="bg-blue-400 flex justify-center items-center align-middle hover:bg-blue-500 rounded-lg admin-button"
        onClick={onClick}
        disabled={loading}
      >
        {!loading ? label : <CircularProgress color="success" size={'12pt'} />}
      </button>
    </div>
  );
};

export default SubmitButton;